import colours from './colours';
export default {
  info: {
    colour: colours.grey_c6
  },
  success: {
    colour: colours.green_60
  },
  warning: {
    colour: colours.yellow_d2
  },
  danger: {
    colour: colours.singtelred_00
  }
};